export const SET_VALUES = 'set_values';
export const TOGGLE_LEFT_SIDEBAR = 'toggle_left_sidebar';
export const TOGGLE_PAGE_VIEW = 'toggle_page_view';
